export default "__VITE_ASSET__DLJd1Z53__"